import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/FeaturedWriteups/FeaturedWriteups.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/Certifications/Certifications.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/SkillsAndTools/SkillsAndTools.module.css");
